import { useDispatch } from 'react-redux';

import { Dialog, DialogContent } from '@mui/material';
import { ClassNameMap } from '@mui/styles';
import { closeModal } from '@stores/actions/modal.action';
import { ModalStore } from '@stores/models/store';

import DialogTitle from './DialogTitle';

interface Props {
  modal: ModalStore;
  classes: ClassNameMap<
    | 'cardContainer'
    | 'closeIcon'
    | 'successIcon'
    | 'modalContainer'
    | 'cardContent'
    | 'confettiWrapper'
  >;
}

const SimpleModal = ({ modal, classes }: Props) => {
  const dispatch = useDispatch();

  return (
    <Dialog
      open={modal.show}
      onClose={(event, reason) => {
        if (
          false === modal.preventClose ||
          (reason !== 'backdropClick' && reason !== 'escapeKeyDown')
        ) {
          dispatch(closeModal());
        }
      }}
    >
      {modal.withHeader && (
        <DialogTitle
          id="customized-dialog-title"
          withCloseBtn={modal.withCloseBtn}
          onClose={() => dispatch(closeModal())}
        >
          {modal.title}
        </DialogTitle>
      )}
      <DialogContent
        className={`${modal.className || ''} ${classes.cardContainer}`}
      >
        {modal.component}
      </DialogContent>
    </Dialog>
  );
};

export default SimpleModal;
